// lodash-wechat-polyfill.js
// See: https://cdmana.com/2021/07/20210731023522858v.html
var g = typeof window !== 'undefined' && window.Math === Math ?
  window :
  typeof global === 'object' ? global : this;

if (!g.Object) {
  g.Object = Object;
}

if (!g.Date) {
  g.Date = Date;
}
